export enum TypeUtilisateur {
    PERSONNE = 'Personne',
    EQUIPEMENT = 'Equipement',
}
